var _path, _path2, _rect, _path3, _circle, _circle2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAverage = function SvgAverage(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49 44H2V5C2 4.44772 1.55228 4 1 4C0.447715 4 0 4.44772 0 5V45C0 45.5523 0.447715 46 1 46H49C49.5523 46 50 45.5523 50 45C50 44.4477 49.5523 44 49 44Z",
    fill: "#FC628F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 35C9.10457 35 10 34.1046 10 33C9.9884 32.834 9.95532 32.6701 9.9016 32.5126L19.5132 22.9018C20.0027 23.0847 20.5511 23.0125 20.9766 22.709L32.0018 29.009C32.0366 30.0897 32.924 30.9471 34.0053 30.9447C35.0865 30.9422 35.9701 30.0809 36 29C35.9884 28.8342 35.9554 28.6705 35.9018 28.5132L45.5126 18.9014C45.6701 18.9553 45.8339 18.9885 46 19C47.1046 19 48 18.1046 48 17C48 15.8954 47.1046 15 46 15C44.8954 15 44 15.8954 44 17C44.0116 17.166 44.0447 17.3299 44.0984 17.4874L34.4868 27.0982C33.9972 26.9153 33.4487 26.9875 33.0232 27.291L21.998 20.991C21.9615 19.9116 21.0746 19.0562 19.9946 19.0586C18.9146 19.061 18.0316 19.9205 18 21C18.0116 21.1658 18.0446 21.3295 18.0982 21.4868L8.4874 31.0986C8.32991 31.0447 8.16606 31.0115 8 31C6.89543 31 6 31.8954 6 33C6 34.1046 6.89543 35 8 35Z",
    fill: "#FC628F"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.88721,
    y: 30.3975,
    width: 41.5703,
    height: 5.5,
    transform: "rotate(-22.31 6.88721 30.3975)",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8214 30.3811L12.1785 32.2859L11.4194 30.4355L16.0623 28.5308L16.8214 30.3811ZM23.3214 27.7145L18.6785 29.6192L17.9194 27.7689L22.5623 25.8641L23.3214 27.7145ZM29.8214 25.0478L25.1785 26.9526L24.4194 25.1022L29.0623 23.1975L29.8214 25.0478ZM36.3214 22.3811L31.6785 24.2859L30.9194 22.4355L35.5623 20.5308L36.3214 22.3811ZM42.8214 19.7145L38.1785 21.6192L37.4194 19.7689L42.0623 17.8641L42.8214 19.7145Z",
    fill: "#FD9CB9"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 17,
    r: 2,
    fill: "#FC628F"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 33,
    r: 2,
    fill: "#FC628F"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAverage);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/average.61bc834ae400823c958fa6ce3fadb61d.svg";